import { render, staticRenderFns } from "./IndividualClaim.vue?vue&type=template&id=2e97fc4c&scoped=true&"
import script from "./IndividualClaim.vue?vue&type=script&lang=js&"
export * from "./IndividualClaim.vue?vue&type=script&lang=js&"
import style0 from "./IndividualClaim.vue?vue&type=style&index=0&id=2e97fc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97fc4c",
  null
  
)

export default component.exports